import { render, staticRenderFns } from "./leadTag.vue?vue&type=template&id=c82f5424&scoped=true"
import script from "./leadTag.vue?vue&type=script&lang=js"
export * from "./leadTag.vue?vue&type=script&lang=js"
import style0 from "./leadTag.vue?vue&type=style&index=0&id=c82f5424&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82f5424",
  null
  
)

export default component.exports